import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { improveAreas } from "../data/mock";
import { Reveal, ChapterTag, EASE } from "../lib/motion";
import { Plus } from "lucide-react";

export const ImproveSection = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="improve" data-testid="improve-section" className="py-24 sm:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="04" label="How I help" />
          <h2 className="mt-6 font-display font-semibold text-stone-900 tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
            {improveAreas.heading}
          </h2>
          <p className="mt-4 text-stone-500 font-display  text-base md:text-lg">{improveAreas.intro}</p>
        </Reveal>

        <div className="mt-14 border-t border-stone-300/70">
          {improveAreas.items.map((area, i) => {
            const Icon = area.icon;
            const isOpen = openIdx === i;
            return (
              <div key={i} className="border-b border-stone-300/70">
                <button
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  data-testid={`improve-row-${i}`}
                  className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                >
                  <div className="flex items-center gap-5 sm:gap-8">
                    <span className="text-xs font-semibold text-brand-600 tracking-[0.2em] w-8">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-300 ${isOpen ? "bg-[#032e2d]" : "bg-brand-100 group-hover:bg-brand-200"}`}>
                      <Icon className={`w-4.5 h-4.5 w-[18px] h-[18px] transition-colors duration-300 ${isOpen ? "text-teal-100" : "text-brand-700"}`} />
                    </div>
                    <h3 className={`font-display font-semibold text-lg sm:text-2xl transition-colors duration-300 ${isOpen ? "text-brand-800" : "text-stone-900 group-hover:text-brand-800"}`}>
                      {area.title}
                    </h3>
                  </div>
                  <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3 }}>
                    <Plus className="w-5 h-5 text-stone-400 flex-shrink-0" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: EASE }}
                      className="overflow-hidden"
                      data-testid={`improve-content-${i}`}
                    >
                      <div className="pb-8 pl-[52px] sm:pl-[120px] flex flex-wrap gap-2.5">
                        {area.examples.map((ex, j) => (
                          <span
                            key={j}
                            className="px-4 py-2 rounded-full bg-white border border-stone-200 text-sm text-stone-600 hover:border-brand-400 hover:text-brand-800 transition-colors duration-200"
                          >
                            {ex}
                          </span>
                        ))}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
